import {
  SmartReportComponentTypesEnum,
  SmartReportLayoutIdsEnum,
  SmartReportTypeEnum,
} from '@/admins/SmartReports/types';

import { TitlePageEdit } from './TitlePageEdit';
import { TitlePageThumbnail } from './TitlePageThumbnail';
import { TitlePageView } from './TitlePageView';

export const TitlePageLayout = {
  id: SmartReportLayoutIdsEnum.TitlePage,
  title: 'Title Page With Hero Image Background',
  description: 'A layout with a title page with a hero image background for reports.',
  Thumbnail: TitlePageThumbnail,
  Component: TitlePageEdit,
  ComponentView: TitlePageView,
  elementTypes: [SmartReportComponentTypesEnum.TextField],
  reportTypes: Object.values(SmartReportTypeEnum),
};
